import { RichText } from "components/RichTextWidget";
import { Container, Heading2 } from "shared/components";

import styles from "./Hero073.module.scss";

export const Hero073 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const description = payload?.description ?? "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading2 className={styles.headline} color="dark">
            {headline}
          </Heading2>
          <RichText
            value={description}
            color="dark"
            className={styles.description}
          />
        </div>
      </Container>
    </div>
  );
};

export default Hero073;
